import { useState } from 'react'
import {
  Pair,
  getQuestionNumberingText,
  getQuestionTypeText,
  getQuestionTypeTextFromRaw
} from './import.utils'

export const useImportValidation = () => {
  const [validationError, setValidationError] = useState<string>('')

  const validateMapping = (pairs: Pair[]) => {
    const mismatchedQuestions: string[] = []

    pairs.forEach((p) => {
      if (
        p.item1 &&
        p.item2 &&
        getQuestionTypeText(p.item1) !== getQuestionTypeTextFromRaw(p.item2)
      ) {
        mismatchedQuestions.push(getQuestionNumberingText(p.item1))
      }
    })

    if (mismatchedQuestions.length > 0) {
      const questionNumbers = mismatchedQuestions.join(', ')
      setValidationError(
        `Question type mismatch detected in ${questionNumbers}. Please ensure imported questions match existing question types.`
      )
      return false
    }

    setValidationError('')
    return true
  }

  const clearValidation = () => {
    setValidationError('')
  }

  return {
    validationError,
    validateMapping,
    clearValidation
  }
}
